import { useCallback, useState } from 'react';

import { useIsAuthenticated } from 'apps/shared/scripts/hooks';

import { OnboardingFormValues } from '../../components/OnboardingForm';
import OnboardingAuthContainer from '../OnboardingAuthContainer';
import OnboardingFormContainer from '../OnboardingFormContainer';

const OnboardingContainer = () => {
  const [stashedFormData, setStashedFormData] = useState<
    OnboardingFormValues | undefined
  >();
  const [showAuth, setShowAuth] = useState<boolean>(false);
  const isAuthenticated = useIsAuthenticated();

  const onUnauthenticated = useCallback((formData: OnboardingFormValues) => {
    setStashedFormData(formData);
    setShowAuth(true);
  }, []);

  const hideAuth = useCallback(() => {
    setShowAuth(false);
  }, []);

  if (showAuth) {
    return (
      <OnboardingAuthContainer
        hideAuth={hideAuth}
        formValues={stashedFormData}
      />
    );
  }

  return (
    <OnboardingFormContainer
      isAuthenticated={isAuthenticated}
      stashedFormData={stashedFormData}
      onUnauthenticated={onUnauthenticated}
    />
  );
};

OnboardingContainer.displayName = 'OnboardingContainer';

export default OnboardingContainer;
